export default "__VITE_ASSET__DuixK1sB__"